<template>

    <a class="dd-m-icon" v-on:click="isUserSigned" :title="title" v-if="!footer">
        <i class="dd-m-icon" :class="icon"></i>
    </a>

    <a v-on:click="isUserSigned" :title="title" class="dd-m-menu__link" v-else>
        <i class="dd-m-icon icon-home"></i> <span>{{title}}</span>
    </a>

</template>
<script>
    import AuthService from '../providers/api/auth-service';

    const authService = new AuthService();

    export default {
        name: 'bar-link',
        props: ['icon', 'title', 'path', 'footer'],
        mounted() {
        },
        methods: {
            isUserSigned() {
                if (authService.isSigned()) {
                    location.href = this.path;
                } else {
                    PubSub.publish('openLoginModal');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/bar-link.vue